
import React from 'react';

export const BlindModeOverlay: React.FC<{ active: boolean }> = ({ active }) => {
    if (!active) return null;

    return (
        <div className="fixed inset-0 z-[2000] bg-[#010204] flex flex-col items-center justify-center animate-fade-in">
            <div className="text-center space-y-10 p-12">
                <div className="w-32 h-32 rounded-full border-4 border-white/5 flex items-center justify-center mx-auto shadow-2xl relative">
                    <div className="absolute inset-0 rounded-full border border-white/20 animate-ping"></div>
                    <span className="text-6xl">🌑</span>
                </div>
                <div className="space-y-4">
                    <h2 className="text-5xl font-black text-white italic uppercase tracking-tighter">Test de Transfert</h2>
                    <p className="text-slate-500 text-sm font-bold uppercase tracking-[0.4em]">Écran masqué • Écoutez votre groove interne</p>
                </div>
                <div className="p-10 bg-white/[0.02] rounded-[48px] border border-white/10 max-w-md mx-auto shadow-inner">
                    <p className="text-sm text-slate-400 italic leading-relaxed">
                        "Un musicien qui ne regarde pas son écran est un musicien qui a automatisé son geste. Prouvez que vous n'avez plus besoin d'aide visuelle."
                    </p>
                </div>
            </div>
            
            <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4">
                <div className="w-1.5 h-1.5 rounded-full bg-white/20 animate-ping"></div>
                <span className="text-[8px] font-black text-slate-700 uppercase tracking-widest">Neural Recording Active</span>
            </div>
        </div>
    );
};
